import {useMutation} from '@apollo/react-hooks';

import type {
    AssociateExternalMeetingWithActivity as AssociateExternalMeetingWithActivityMutation,
    AssociateExternalMeetingWithActivityVariables as AssociateExternalMeetingWithActivityMutationVariables,
} from 'nutshell-graphql-types';

import ASSOCIATE_EXTERNAL_MEETING_WITH_ACTIVITY from '../mutations/associate-external-meeting-with-activity.graphql';

export function useAssociateMeetingWithActivity(): (id: string) => Promise<any> {
    const [associateMeetingWithActivity] = useMutation<
        AssociateExternalMeetingWithActivityMutation,
        AssociateExternalMeetingWithActivityMutationVariables
    >(ASSOCIATE_EXTERNAL_MEETING_WITH_ACTIVITY);

    return (id: string) =>
        associateMeetingWithActivity({
            variables: {input: {id}},
        });
}
